/** @jsx h */
/** @jsxFrag Fragment */
import { h, Fragment } from "preact";

import { FormInputProps } from "./common";
import LegalInput from "./async/Legal";
import DateOfBirthInput from "./async/DateOfBirth";
import DatePickerInput from "./async/DatePicker";
import MultiSelectInput from "./async/MultiSelect";
import RadioInput from "./async/RadioInput";
import RangeInput from "./async/Range";
import SelectInput from "./async/Select";
import TextAreaInput from "./async/TextArea";
import TextInput from "./async/TextInput";
import PhoneNumber from "./async/PhoneNumber";
import Image from "./async/Image";
import Ranking from "./async/Ranking";
import StarRating from "./async/StarRating";
import { ContentBlock } from "../FormTypes";
import TextContent from "./async/TextContent";
import FileUpload from "./async/FileUpload";

export const FormInput = (props: FormInputProps) => {
  const { visible } = props;

  if (!visible) {
    return null;
  }

  switch (props.input_type) {
    case "checkbox":
      return <LegalInput {...props} />;
    case "textarea":
      return <TextAreaInput {...props} />;
    case "text":
    case "email":
      return <TextInput {...props} />;
    case "radio":
      return <RadioInput {...props} />;
    case "select":
      return <SelectInput {...props} />;
    case "multi-select":
      return <MultiSelectInput {...props} />;
    case "phone":
      return <PhoneNumber {...props} />;
    case "date":
      return <DatePickerInput {...props} />;
    case "dob":
      return <DateOfBirthInput {...props} />;
    case "nps":
    case "agree_disagree":
      return <RangeInput {...props} />;
    case "ranking":
      return <Ranking {...props} />;
    case "star_rating":
      return <StarRating {...props} />;
    case "file":
      return <FileUpload {...props} />;
    default:
      return null;
  }
};

type FormContentProps = ContentBlock & { isHeading?: boolean };

export const FormContent = ({ isHeading, ...props }: FormContentProps) => {
  switch (props.block_type) {
    case "image":
      return <Image {...props} />;
    case "text_content":
      return <TextContent isHeading={isHeading} {...props} />;
    default:
      return null;
  }
};
